import React, { useEffect, useState } from "react";
import ProjectTypesOneCard from "./ProjectTypesOneCard";
import SectionTitle from "../../section-title/SectionTitle";
import axios from "axios";

const ProjectsTypeOne = () => {
  const [homeWeAre, setHomeWeAre] = useState(null);
   const [home, setHome] = useState(null);
  const fetchHomeWeare = async () => {
    try {
      const response = await axios.get(
         "https://portal.ebs365.info/api/sites/3/list/gallery"
      );
      setHomeWeAre(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchHomeWeare();
  }, []);

  // console.log("Fetched Data:", homeWeAre);
  let heroSection = null;
  if (homeWeAre && homeWeAre.data && homeWeAre.data) {
    heroSection = homeWeAre.data;
  }
  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await fetch(
          "https://portal.ebs365.info/api/sites/3/pages/home"
        );
        const data = await response.json();
        setHome(data);
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    };

    fetchSiteSettings();
  }, []);


  let heroSections = null;
  if (home && home.data && home.data.sections) {
    heroSections = home.data.sections.find(
      (section) => section.title === "home_gallery"
    );
  }



  return (
    <>
      {/* Project Section Start */}
      <div className="project-sec pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                
                
              <SectionTitle
                title="<span>Our Gallery </span>Photo"
                content={heroSections && heroSections.items && heroSections.items[0] && heroSections.items[0].contents && heroSections.items[0].contents.subtitle ? heroSections.items[0].contents.subtitle : null}
              />
            </div>
          </div>
          <div className="row">
            {heroSection
              ? heroSection &&
                heroSection.map(
                  (data, i) => (
                      <div key={i} className="col-xs-6 col-sm-4 col-md-4">
                        <ProjectTypesOneCard
                          key={data.id}
                          data={data}
                        //   extraClass={"col-xs-6 col-sm-4 col-md-4"}
                        />
                      </div>
                    )
                )
              : null}

          
          </div>
        </div>
      </div>
      {/* Project Section Start */}
    </>
  );
};

export default ProjectsTypeOne;
